import React from "react";
import EditPaymentLogTimeLine from "./EditPaymentLogTimeLine";
import EditPaymentDetails from "./EditPaymentDetails";
import FolioWidget from "./FolioWidget";
import EditFolioWidget from "./EditFolioWidget";
import IncidentalDepositDetails from "./IncidentalDepositDetails";
import CustomerSelect from "../Selects/CustomerSelect";
import CreditCardForm from "../BookingFlow/CreditCardForm";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import DateHelper from "../DateHelper/DateHelper";
import ErrorHelper from '../Errors/ErrorHelper';
import { format, parseISO } from 'date-fns';

class PaymentBuilderGeneral extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      guestVisible: false
    }

    this.onToggleGuestVsCustomer = this.onToggleGuestVsCustomer.bind(this);
  };

  render() {
    if (this.props.activeTab === 'general' && !this.props.payment_log.voided_at) {
      return (
        <div>
          {!this.props.new_record ? <EditPaymentLogTimeLine {...this.props} /> : null}
          {this.renderHeaderErrors()}
          {this.renderIncidentalOrFolios()}
          {this.props.new_record ? this.renderPaymentDetails() : <EditPaymentDetails {...this.props} />}
          {this.props.new_record || this.props.capture_auth ? this.renderPaymentTotalBanner() : null}
        </div>
      );
    } else if (this.props.activeTab === 'general' && this.props.payment_log.voided_at){
      return(
        <div className="alert alert-dismissable alert-warning">
          <p>{I18n.t('void_auths_can_not_be_captured')}</p>
        </div>
      );
    };
  };

  renderIncidentalOrFolios() {
    if (this.props.incidental_deposit_payment) {
      return this.renderIncidentalDepositDetails();
    } else if (this.props.new_auth_payment) {
      return this.renderAuthAmount()
    } else if (this.props.payment_log.payment_type && this.props.payment_log.payment_type.name !== 'voucher' && this.props.payment_log.vouchers.length) {
      return this.renderVoucherDetails();
    } else {
      return this.renderFolios();
    };
  };

  renderFolios() {
    if (this.props.ignoreFolios) {
      return null;
    }
    
    return (
      <div className="folio-widget">
        {
          this.props.new_record || this.props.capture_auth
            ?
            <FolioWidget {...this.props} hasClassErrors={this.hasClassErrors} renderFieldErrors={this.renderFieldErrors} disablAmount={this.props.disableNameOnCard} />
            :
            <EditFolioWidget {...this.props} />
        }
      </div>
    );
  };

  renderIncidentalDepositDetails() {
    return (
      <IncidentalDepositDetails {...this.props} />
    );
  };

  renderPaymentDetails() {
    return (
      <div className="payment-details">
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t('payment_details')}</h3>
            <div className="payment-details-wrapper">
              <div className="row">
                {this.renderPaymentType()}
                {this.renderCustomer()}
              </div>
              {this.renderCardCashOrVoucher()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCardCashOrVoucher = () => {
    if (this.props.payment_type === 'capture' || this.props.payment_type === 'auth_and_hold_amount') {
      return this.renderCards();
    } else if(this.props.payment_type === 'voucher') {
      return this.renderVoucher();
    } else if(this.props.payment_type === 'cash') {
      return this.renderCash()
    };
  };

  renderPaymentType() {
    return (
      <div className='col-md-4 payment-type-select'>
        <div className="form-group">
          <label>{I18n.t('payment_type')}</label>
          {
            this.props.payment_type === 'auth_and_hold_amount'
            ?
              <p>{I18n.t('auth_and_hold_amount')}</p>
            :
              <select className="form-control" value={this.props.payment_type} name="paymentType" onChange={this.props.onChangePaymentType} disabled={this.props.disableNameOnCard} >
                <option value="capture">{I18n.t('card')}</option>
                <option value="cash">{I18n.t('cash')}</option>
                {this.props.imported_reservation ? <option value="system_import">{I18n.t('system_import')}</option> : null}
                <option value="voucher">{I18n.t('voucher')}</option>
              </select>
          }
        </div>
      </div>
    );
  };

  renderCustomer() {
    return (
      <div className="col-md-8 customer-select">
        <div className="form-group">
          <label>{I18n.t('customer')} {!this.props.customerOptional ? '*' : ''}</label>
          <CustomerSelect 
            customer={this.props.customer} 
            onChange={this.props.onChangeCustomer} 
            allowClear={this.props.incidental_deposit_payment ? false : true} 
            callSource={'paymentBuilder'} 
            reservation_segment={this.props.reservation_segment} 
            disabled={((this.props.payment_type === 'capture' || this.props.payment_type === 'auth_and_hold_amount') && this.state.guestVisible) || this.props.disableNameOnCard}
            error={this.props.errors ? ErrorHelper.renderFieldErrors('customer', this.props.errors.field_errors) : false}
            />
          {this.props.errors ? ErrorHelper.renderFieldErrors('customer', this.props.errors.field_errors) : ''}
          <a href="/admin/customers/new" data-fullscreen="true" data-nested="true" className="modal-iframe">{I18n.t('new_customer')}</a>
        </div>
      </div>
    );
  };

  renderVoucher() {
    if(this.props.voucher){
      return (
        <div className="redeemed-voucher-wrapper">
          <div className="row">
            <div className="form-group col-md-4">
              <label>{I18n.t('redemption_code')}</label>
              <div>{this.props.voucher.redemption_code}</div>
              <button className="btn btn-primary remove-voucher-code" onClick={this.props.removeVoucher} >{I18n.t('remove')}</button>
            </div>
            <div className="form-group col-md-4">
              <label>{I18n.t('balance')}</label>
              <div>{this.props.formatCurrency(this.props.voucher.balance)}</div>
            </div>
          </div>
        </div>
      )
    } else {
      return(
        <div className="row">
          <div className="form-group col-md-4">
            <label>{I18n.t('redemption_code')}</label>
            <input className={this.hasClassErrors('enter_voucher_redemption_code') ? "form-control has-errors" : "form-control"} name="redemption_code" value={this.props.redemption_code} onChange={this.props.onChange} />
            {this.renderFieldErrors('enter_voucher_redemption_code')}
            <button className="btn  btn-primary enter-voucher-code" onClick={this.props.getVoucher} >{I18n.t('enter')}</button>
          </div>
        </div>
      );
    };
  };

  renderCash() {
    const cash_drawers = this.props.cash_drawers.map((cash_drawer) => {
      return <option key={cash_drawer.id} value={cash_drawer.id}>{cash_drawer.name}</option>
    })
    cash_drawers.unshift(<option key="none" value="" disabled>{I18n.t('choose')}</option>);

    return (
      <div className="row">
        <div className='col-md-4'>
          <div className="form-group">
            <label>{I18n.t('cash_drawer')}</label>
            <select className={this.props.errors && this.props.errors.header_errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Cash Drawer')) ? "form-control has-errors" : "form-control"} name="cash_drawer_id" value={this.props.cash_drawer_id} onChange={this.props.onChangeCashDrawer}>
              {cash_drawers}
            </select>
            {this.props.errors && this.props.errors.header_errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Cash Drawer')) ? <div className="help-block"><ul><li><b>&#x2022;</b>{I18n.t('cant_be_blank')}</li></ul></div> : null}
          </div>
        </div>
      </div>
    );
  }

  renderCards() {
    if (!this.props.addNewCardVisible && this.props.customer && this.props.customer.cards && this.props.customer.cards.length) {
      var cards = this.props.customer.cards.map((card) => {
        return (
            <div className={"card " + (this.props.card && this.props.card.id == card.id ? 'card-selected' : '')} key={card.id}>
              <label onClick={() => this.props.onChangeCard(card.id)} className="customer-cards-label">
                <div className="radio-and-icon">
                  <input type="radio" name="card_id" value={card.id} checked={this.props.card && this.props.card.id == card.id ? true : false} onChange={() => this.props.onChangeCard(card.id)} />
                  <span className={"credit-card-icon small " + card.brand}></span>
                </div>
                <div className="card-details">
                  <span>{I18n.t('ending_in').toLowerCase()}</span> <strong>{card.last_4}</strong> 
                  <span>{I18n.t('exp')}</span> <strong>{card.month}/{card.year}</strong> 
                  <span>{I18n.t('last_payment')}</span> <strong>{card.last_payment_date ? format(parseISO(card.last_payment_date), DateHelper.rubyToDateFNS(this.props.date_format)) : I18n.t('none')}</strong>
                  {this.props.hideCardSource  ? '' : <span>{this.renderCardAssociations(card)}</span>}
                </div>
              </label>
            </div>
        );
      });
    };
    
    return (
      <div className="row">
        <div className={(this.hasClassErrors('select_or_enter_payment_details')) || (this.props.errors && this.props.errors.header_errors && this.props.errors.header_errors.find(error => error === 'Customer card already exists. Please select from existing cards list.')) ? "col-md PaymentMethod has-errors" : "col-md PaymentMethod"}>
          {
            this.props.customer && this.props.customer.cards && this.props.customer.cards.length
            ? 
            <span><a href="#" onClick={this.props.toggleAddNewCard}>{I18n.t(this.props.addNewCardVisible ? 'use_existing_cards' : 'add_new_card')}</a></span> 
            : 
            null
          }
          {
            (!this.props.customer || (this.props.customer && (this.props.customer.cards && this.props.customer.cards.length === 0) || this.props.addNewCardVisible))
              ?
              <CreditCardForm
                card={this.props.card}
                onChangeCardInput={this.props.onChangePaymentDetails}
                errors={this.props.errors}
                customer={this.props.customer}
                saveCard={true}
                adjustPadding={true}
                hasClassErrors={this.hasClassErrors}
                renderFieldErrors={this.renderFieldErrors}
                disableNameOnCard={this.props.disableNameOnCard}
                incrementCardElementKey={this.props.incrementCardElementKey}
                cardElementKeyIncremented={this.props.cardElementKeyIncremented}
                additionalClasses="container"
                cardInputWidth="col-md-8"
                nameOnCardInputWidth="col-sm-4"
              />
              :
              cards && cards.length ? <div className="cards">{cards}</div> : null
          }
        </div>
      </div>
    );
  };

  renderAuthAmount() {
    return (
      <div className="panel panel-default">
        <div className="panel-body container">
          <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, marginTop: 5, marginBottom: 10 }}>{I18n.t('authorization_details')}
          </h3>
          <div className="row" style={{ margin: '0px' }}>
            <div className="col-sm-3" style={{ marginTop: '20px' }}>
              <label>{I18n.t('amount')} *</label>
              <CurrencyInput name="amount" value={this.props.amount} className={this.props.errors && this.props.errors.header_errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Amount')) ? "form-control has-errors" : "form-control"} onChange={this.props.onChangeAuthAmount} disabled={this.props.disableNameOnCard} />
              {this.props.errors && this.props.errors.header_errors && this.props.errors.header_errors.length && this.props.errors.header_errors.find(error => error.includes('Amount')) ? <div className="help-block"><ul><li><b>&#x2022;</b>{this.props.errors.header_errors.find(error => error.includes('Amount'))}</li></ul></div> : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPaymentTotalBanner() {
    if (this.props.amount && this.props.amount != 0) {
      return (
        <div className="accommodations-price-footer">
          <p className="lead" style={{ marginBottom: 0 }}>
          {
            this.props.voucher
            ?
              <span  style={{ marginBottom: 0 }}>
                <label style={{ marginBottom: 0 }}>{I18n.t('voucher_balance')}:</label>&nbsp;
                {this.props.formatCurrency(this.props.voucher.balance)}{this.renderChangeDue()}&nbsp;
              </span>
            :
            null
          }
            <label style={{ marginBottom: 0 }}>{I18n.t('total')}:</label>&nbsp;
            {this.props.formatCurrency(this.props.amount)}{this.renderChangeDue()}
          </p>
        </div>
      );
    } else {
      null
    }
  };

  renderChangeDue() {
    const change_due = this.props.cash_received_amount - this.props.amount
    if (this.props.payment_type === 'cash' && this.props.cash_received_amount > 0 && change_due > 0) {
      return <span>, {I18n.t('change_due')}: {this.props.formatCurrency(change_due)}</span>
    }
  }

  renderHeaderErrors() {
    if (this.props.errors && this.props.errors.header_errors) {
      var previousNameError = false
      var errors = this.props.errors.header_errors.map((error, idx) => {
        if (error.toLowerCase().includes('name')) {
          if (!previousNameError) {
            previousNameError = true
            return <li key={idx}>{I18n.t('name_on_card_error')}</li>;
          };
        } else if (error.toLowerCase().includes('number') || error.toLowerCase().includes('month') || error.toLowerCase().includes('year') || error.toLowerCase().includes('amount')) {
          return <li key={idx}>{error}</li>;
        } else if (error.toLowerCase().includes('verification value')) {
          return <li key={idx}>{I18n.t('security_code_error')}</li>
        } else return <li key={idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
    if (this.props.voucher_errors && this.props.voucher_errors.length) {
      var idx = 0;
      var errors = this.props.voucher_errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );

    }
  };

  renderVoucherDetails = () => {
    const vouchers = this.props.payment_log.vouchers.map((voucher) => {
      return(
        <div className="folio-amount" key={voucher.id}>
          <div className="row" style={{ margin: '0px' }}>

            <div className="col-sm-2">
              <label>{I18n.t('redemption_code')}</label>
              <br />
              <div>{voucher.redemption_code}</div>
            </div>

            <div className="col-sm-1">
              <label>{I18n.t('amount')}</label>
              <br />
              <div>{this.props.formatCurrency(voucher.amount)}</div>
            </div>

            <div className="col-sm-3">
              <label>{I18n.t('customer')}</label>
              <br />
              <div>{voucher.customer_name ? voucher.customer_name : I18n.t('none')}</div>
            </div>

            <div className="col-sm-3">
              <label>{I18n.t('expiration_date')}</label>
              <br />
              <div>{voucher.expiration_date ? DateHelper.printDateToScreen(voucher.expiration_date, this.props.date_format) : I18n.t('none')}</div>
            </div>

            {
              this.props.payment_log.payment_type.name === 'cash'
                ?
                null
                :
                <div className="col-sm-3">
                  <label>{I18n.t('refunded')}</label>
                  <div>{this.props.formatCurrency(this.props.amount_refunded)}</div>
                  {
                    this.props.amount_refunded == this.props.payment_log.amount
                      ?
                      null
                      :
                      <div onClick={(e) => this.props.onClickRefundVoucher(e, voucher.id)} >
                        <button className="btn btn-secondary modal-iframe btn-xs" style={{ marginBottom: "2px" }}><span className='ss-write'><span style={{ marginLeft: 5 }}>{I18n.t('refund')}</span></span></button>
                      </div>
                  }
                </div>
            }

          </div>
        </div>
      );

    });

    return (
      <div className="panel panel-default">
        <div className="panel-body container">
          <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF' }}>{I18n.t('purchased_vouchers')}</h3>
          <div className={"folios "}>
            {vouchers && vouchers.length ? vouchers : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
          </div>
        </div>
      </div>
    );
  }

  renderFieldErrors = (braketReference) => {
    if (this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[braketReference]){
      return <div className="help-block" key={this.props.errors.field_errors[braketReference]}><ul><li><b>&#x2022;</b>{this.props.errors.field_errors[braketReference]}</li></ul></div>
    };
  };

  hasClassErrors = (braketReference) => {
    if (this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[braketReference]) {
      return  true;
    } else {
      return false;
    };
  };

  renderCardAssociations = (card) => {
    if (card.reservation_card && card.display_with_customer && card.room_incidental_card) {
      return (`(${I18n.t('reservation_booking_card')}, ${I18n.t('room_incidental_card')}, ${I18n.t('saved_customer_card')})`);
    } else if (card.reservation_card && card.room_incidental_card) {
      return (`(${I18n.t('reservation_booking_card')}, ${I18n.t('room_incidental_card')})`);
    } else if (card.reservation_card && card.display_with_customer) {
      return (`(${I18n.t('reservation_booking_card')}, ${I18n.t('saved_customer_card')})`);
    } else if (card.reservation_card) {
      return (`(${I18n.t('reservation_booking_card')})`);
    } else if (card.room_incidental_card && card.display_with_customer) {
      return (`(${I18n.t('room_incidental_card')}, ${I18n.t('saved_customer_card')})`);
    } else if (card.room_incidental_card) {
      return (`(${I18n.t('room_incidental_card')})`);
    } else if (card.display_with_customer) {
      return (`(${I18n.t('saved_customer_card')})`);
    };
  };

  onToggleGuestVsCustomer() {
    this.setState({ guestVisible: !this.state.guestVisible }, () => {
      this.props.onChangeCustomer(null);
    });
  }

};

export default PaymentBuilderGeneral
